import React from "react";

import { X } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import Spinner from "../../../common/Spinner/Spinner";
import NeftModal from "../Handholder/NeftModal";

import ConfirmationModal from "./ConfirmationModal";
import RefundModal from "./RefundModal";

export default function StateChangeModalSPM(props) {
	return (
		<Modal
			isOpen={props.isOpen}
			onRequestClose={props.toggleModal}
			ariaHideApp={false}
		>
			<ModalContent>
				{props.service ? (
					<div className={`status-column`}>
						{props.isLoading && <Spinner className=" center" />}

						<div className={`p-2 modal-header-bar`}>
							<span>Change Status</span>
							<button
								type="button"
								className="close"
								aria-label="Close"
								onClick={props.toggleModal}
							>
								<X
									style={{ pointerEvents: "none" }}
									color="white"
								/>
							</button>
						</div>

						<div
							className={`${
								props.service["sDeliveryMods"] === "Self-Served"
									? "disable-modal"
									: ""
							}   ${props.isLoading && "set-opacity"} `}
						>
							<label
								className={`container1 ${props.service.statusArray[0]}`}
							>
								Ready for progression
								<input
									name="readyForProgression"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									type="checkbox"
									checked="checked"
								></input>
								<span
									name="readyForProgression"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									className={`checkmark ${props.service.statusArray[0]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[1]}`}
							>
								Payment Confirmed By Partner
								<input
									name="paymentConfirmedByPartner"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									type="checkbox"
									checked="checked"
								></input>
								<span
									name="paymentConfirmedByPartner"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									class={`checkmark ${props.service.statusArray[1]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[2]}`}
							>
								Awaiting For Information/Documents
								<input
									name="AwaitingForInformationDocuments"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									type="checkbox"
									checked="checked"
								></input>
								<span
									name="AwaitingForInformationDocuments"
									onClick={(f) =>
										props.handleClick(f, props.service)
									}
									class={`checkmark ${props.service.statusArray[2]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[3]}`}
							>
								Service Delivery Start
								<input
									name="serviceDeliveryStarted"
									onClick={(f) =>
										props.service.statusArray[3] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="serviceDeliveryStarted"
									onClick={(f) =>
										props.service.statusArray[3] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[3]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[4]}`}
							>
								Service Deliverables Ready
								<input
									name="serviceDeliverablesReady"
									onClick={(f) =>
										props.service.statusArray[4] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="serviceDeliverablesReady"
									onClick={(f) =>
										props.service.statusArray[4] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[4]}`}
								></span>
							</label>
							<div class="payment-links">
								<div
									className={`underlined-action  ${
										props.service["sPaymentMode"] ===
										"2_Step_Payment"
											? ""
											: "disabled"
									}  ${props.service.statusArray[5]}`}
									onClick={(f) =>
										props.toggleNeftModal(props.service)
									}
								>
									{props.service["refCurrentState"][
										"sServiceState"
									] === "Full Payment Received"
										? "View NEFT Details"
										: "Add NEFT Details"}
								</div>
								<div
									style={{
										display: "flex",
									}}
								>
									<div
										className={`underlined-action ${
											props.service["sPaymentMode"] ===
											"2_Step_Payment"
												? ""
												: "disabled"
										}${
											props.service["sPaymentStatus"] ===
											"Credit"
												? "disabled"
												: ""
										} ${props.service.statusArray[5]}`}
										onClick={(f) =>
											props.sendPaymentLink(props.service)
										}
									>
										Send Payment Link
									</div>
									<div
										className={`payment-color-label ${
											props.service["sPaymentStatus"] ===
											null
												? props.service[
														"urlPayment"
												  ] !== null
													? "PaymentPending"
													: "NotSent"
												: props.service[
														"sPaymentStatus"
												  ] === "Credit"
												? "PaymentReceived"
												: "PaymentFailed"
										} ${
											props.service["sPaymentMode"] ===
											"2_Step_Payment"
												? ""
												: "disabled"
										} ${
											props.service["sPaymentStatus"] ===
											"Credit"
												? "disabled"
												: ""
										}
                  `}
									>
										<small>
											<label>
												{props.service[
													"sPaymentStatus"
												] === null
													? props.service[
															"urlPayment"
													  ] !== null
														? "Payment Pending"
														: "Not Sent"
													: props.service[
															"sPaymentStatus"
													  ] === "Credit"
													? "Payment Received"
													: props.service[
															"sPaymentStatus"
													  ] === "Failed"
													? "Payment Failed"
													: "Payment Link Deactivated"}
											</label>
										</small>
									</div>
								</div>
							</div>
							<label
								class={`container1 ${props.service.statusArray[5]}`}
							>
								Full Payment Requested
								<input
									name="requestFullPayments"
									onClick={(f) =>
										props.service.statusArray[5] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="requestFullPayments"
									onClick={(f) =>
										props.service.statusArray[5] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[5]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[6]}`}
							>
								Full Payment Received
								<input
									name="fullPaymentReceived"
									onClick={(f) =>
										props.service.statusArray[6] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="fullPaymentReceived"
									onClick={(f) =>
										props.service.statusArray[6] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[6]}`}
								></span>
							</label>
							<label
								class={`container1 ${props.service.statusArray[7]}`}
							>
								Delivered
								<input
									name="delivered"
									onClick={(f) =>
										props.service.statusArray[7] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									type="checkbox"
								></input>
								<span
									name="delivered"
									onClick={(f) =>
										props.service.statusArray[7] ===
										"disable"
											? ""
											: props.handleClick(
													f,
													props.service
											  )
									}
									class={`checkmark ${props.service.statusArray[7]}`}
								></span>
							</label>
							{
								props.service["refCurrentState"]["sServiceState"] 
								=== "Cancelled"?
								(
									<label
										class={`container1 ${props.service.statusArray[8]}`}
									>
										Cancelled
										<input
											name="cancelled"
											type="checkbox"
										></input>
										<span
											name="cancelled"
											class={`checkmark ${props.service.statusArray[8]}`}
										></span>
									</label>
								):
								(
									<label
										class={`container1 ${props.service.statusArray[8]}`}
									>
										Cancelled
										<input
											name="cancelled"
											onClick={(f) =>
												props.handleClick(f, props.service)
											}
											type="checkbox"
										></input>
										<span
											name="cancelled"
											onClick={(f) =>
												props.handleClick(f, props.service)
											}
											class={`checkmark ${props.service.statusArray[8]}`}
										></span>
									</label>
								)
							}

							<div class="payment-links"> 
								<div className={`underlined-action  
									${
										props.service["refCurrentState"]["sServiceState"]
										==="Delivered"? "disabled": ""
									}`}
									onClick={(f) =>
										props.toggleRefundModal(props.service)
									}
								>
									{props.service["bRefund"]===true
										? "View Refund Details"
										: "Add Refund Details"}
								</div>
							</div>
						</div>
						<ConfirmationModal
							message={props.message}
							isOpen={props.isOpenConfirmation}
							toggleModal={props.toggleConfirmationModal}
							changeState={props.changeState}
						/>
						<NeftModal
							isDisabled={
								props.service["refCurrentState"][
									"sServiceState"
								] === "Full Payment Received"
									? "disable"
									: ""
							}
							isOpen={props.isNeftModalOpen}
							toggleModal={props.toggleNeftModal}
							neftDetails={props.neftDetails}
							onInputChange={props.onNeftDetailsChanged}
							onSaveNeftDetails={props.onSaveNeftDetails}
							showSendNeftDetailsModal={
								props.showSendNeftDetailsModal
							}
							setShowSendNeftDetailsModal={
								props.setShowSendNeftDetailsModal
							}
							nResourceInstanceId={
								props.service.nResourceInstanceId
							}
						/>

						<RefundModal
							isDisabled={
								props.service["refCurrentState"]["sServiceState"] === "Delivered"?
								"disable": ""
							}
							service={props.service}
							isOpen={props.isRefundModalOpen}
							toggleModal={props.toggleRefundModal}
							refundDetails={props.refundDetails}
							onInputChange={props.onRefundDetailsChanged}
							onSaveRefundDetails={props.onSaveRefundDetails}
							nResourceInstanceId={props.service.nResourceInstanceId}
							isLoading={props.isLoadingRefund}
							cancellationReasonDropdownOptions={props.cancellationReasonDropdownOptions}
							onSelectCancellationReasonforRefund={props.onSelectCancellationReasonforRefund}
							selectedCancellationReasonforRefund={props.selectedCancellationReasonforRefund}
							enableOtherDescriptionTextboxforRefund={props.enableOtherDescriptionTextboxforRefund}
							cancellationReasonOtherDescriptionforRefund={props.cancellationReasonOtherDescriptionforRefund}
							onChangeCancellationReasonOtherDescriptionforRefund={props.onChangeCancellationReasonOtherDescriptionforRefund}
						/>
					</div>
				) : (
					""
				)}
			</ModalContent>
		</Modal>
	);
}
